export const PAGE_SIZE_OPTIONS: App.OptionsFnc = (t) => [
  { label: '10', value: 10 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
  { label: '200', value: 200 },
];
